<template>
  <div class="full-height">
    <div class="row container-crud q-px-sm">
      <div class="fit">
        <q-card class="q-px-sm">
          <q-card-section class="q-py-sm">
            <div class="crud-title">
              <translate>VIEW_REGISTRATION</translate>
            </div>
          </q-card-section>
          <q-card-section class="q-px-lg">
            <q-btn
                color="grey-3"
                text-color="primary"
                icon="perm_contact_calendar"
                class="view-button-carrier"
                flat
                :label="$gettext('DATA_COMPLETE')"
                @click="openModel"
                :disabled="!this.elements[0].dadosForm.person"
              >
                <q-tooltip>{{ $gettext('VIEW_COMPLETE_DATA') }}</q-tooltip>
              </q-btn>
            <jt-dynamic-form
              ref="dynamicForm"
              :inputs="elements[0].inputs"
              :relacionamentos="elements[0].relacionamentos"
              :model="elements[0].dadosForm"
              :interface="elements[0].nmInterface"
              form-class="form dynamic"
            />
          </q-card-section>
          <q-dialog v-if="flModal" v-model="flModal">
            <q-layout
              view="Lhh lpR fff"
              container
              class="bg-white modal-medium"
            >
              <q-header class="bg-primary">
                <q-toolbar>
                  <q-toolbar-title>{{
                    $gettext("VIEW_COMPLETE_DATA")
                  }}</q-toolbar-title>
                  <q-btn
                    v-close-popup
                    flat
                    round
                    dense
                    size="1.5em"
                    icon="cancel"
                  />
                </q-toolbar>
              </q-header>
              <q-page-container class="card-container-modal">
                <page
                  :name="pageDialog.name"
                  :params="pageDialog.params"
                  :forms="pageDialog.forms"
                />
              </q-page-container>
            </q-layout>
          </q-dialog>
        </q-card>
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtDynamicForm } from 'jtech-webcomps'
import { repository } from 'jtech'
const { page } = JtCrud

@Component({
  mixins: [page],
  name: 'CarrierDetailPage',
  components: { JtDynamicForm, page },
  props: {
    name: String,
    forms: { type: Array, required: true },
    params: Object,
    parent: Object
  }
})
class CarrierDetailPage extends Vue {
  flModal = false;
  pageDialog = null;

  async openModel () {
    const params = { id: this.elements[0].dadosForm.person }
    const forms = await repository.resolve('carrier.detalharCustom', params)
    this.formatContactsPerson(forms[0].dadosForm.contactPersons)
    this.pageDialog = {
      name: 'label',
      params: params,
      forms: forms
    }
    this.flModal = true
  }

  formatContactsPerson (contactsPerson) {
    contactsPerson.forEach((row, index) => {
      if (row.contactPersonEmails?.length) {
        row.contactPersonEmailsMain = row.contactPersonEmails[0].email
        row.contactPersonEmailsSub = row.contactPersonEmails
          .slice(1, row.contactPersonEmails.length)
          .map(e => e.email)
          .join(', ')
      }

      if (row.contactPersonPhones?.length) {
        row.contactPersonPhonesMain = row.contactPersonPhones[0].phone
        row.contactPersonPhonesSub = row.contactPersonPhones
          .slice(1, row.contactPersonPhones.length)
          .map(e => e.phone)
          .join(', ')
      }
    })
  }
}
export default CarrierDetailPage
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

.view-button-carrier{
  position: absolute;
  top: -46px;
  right: 14px;
  border-radius: 5px;
}

</style>
